import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";
import { requests } from ".";

const SpmAppengineService = {
  sendingLimit: (type: string, locationId: string, limit: string) =>
    requests(SERVICE_NAME.APPENGINE_API)
      .log({
        entityId: locationId,
        entityType: EntityType.LOCATION,
        module: Module.ISV,
      })
      .get(
        `support/set-sending-limit?type=${type}&limit=${limit}&locationId=${locationId}`
      ),

  searchLogs: (documentId: string, collection: string, range: number) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `support/document-dates/${documentId}`,
      { params: { collection, range } }
    ),

  getAgencyAdmins: (relNo: string) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `support/agency/get_admins/${relNo}`
    ),

  checkMultipleUsers: (email: string, query?: string) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `account/check-multiple-users/${email}${query}`
    ),

  supportGetRequest: (url: string) =>
    requests(SERVICE_NAME.APPENGINE_API).get(url),

  companyVerification: (searchBy: string, searchTerm: string) =>
    requests(SERVICE_NAME.APPENGINE_API).post(
      `support/verification?search_by=${searchBy}`,
      {
        search_term: searchTerm,
      }
    ),

  reEnableLoopedDocument: (automationId: string, type: string) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `re-enable-looped-document/${automationId}`,
      { params: { type } }
    ),

  getDeletedDocuments: (
    locationId: string,
    documentType: string,
    params?: any
  ) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `location/${locationId}/deleted_${documentType}s`,
      { params }
    ),

  restoreDocument: (documentType: string, documentId: string) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `${documentType}/restore/${documentId}`
    ),

  getDeletedLocations: (companyIdOrRelationshipNumber: string, locationName: string, limit: number = 50, offset: number = 0) =>
    requests(SERVICE_NAME.LOCATIONS_API).get(
      `support/${companyIdOrRelationshipNumber}/deleted-locations?name=${locationName}&limit=${limit}&offset=${offset}`
    ),

  getCompanyIdFromCompanyEmail: (companyEmail: string) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `support/get_company_id?company_email=${companyEmail}`
    ),

  getAgencies: (relationshipNumber: string) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `support/billing/get_agencies?search_term=${relationshipNumber}&search_by=relationship_number&limit=20`
    ),

  getTwilioAssociatedDetails: (twilioSID: string) =>
    requests(SERVICE_NAME.APPENGINE_API).get(
      `twilio/fetch-subaccount/${twilioSID}`
    ),

  getTwilioPhoneInfo: (payload: any) =>
    requests(SERVICE_NAME.APPENGINE_API).post("twilio/phone_lookup", payload),

  resetContactDND: (payload: any) =>
    requests(SERVICE_NAME.APPENGINE_API).post(
      "support/reset-contact-dnd",
      payload
    ),
};

export default SpmAppengineService;
